import axios from "axios";

// const stripePromise = loadStripe(strip_public_key);

export const handleBuyCredit = async (type, price, credit, userId) => {
    try {
        const response = await axios.post(
          "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/create.php",
          {
            userId: userId,
            price: price * 100,
            credit: credit,
            type: type, // "one-time" or "subscription"
          }
        );

        return response.data.status;

    } catch(error) {
        console.log(error)
    }

};